<template>
  <div class="campaign-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first"><h3>{{$t('campaign.campaign')}}</h3></strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('campaign.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('campaign.basic_information') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <b-form-group v-bind:label="$t('campaign.code')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.code"
                      :state="!$v.item.code.$invalid"
                      :aria-describedby="'name-seo-feedback'"
                    />
                    <b-form-invalid-feedback :id="'name-seo-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('campaign.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="item.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                      />
                    </div>
                  </div>
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('campaign.name_seo')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="item.name_seo[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                      />
                    </div>
                  </div>
                  <div class="form-group row" >
                    <legend class="col-sm-2 col-form-label">{{$t('campaign.description')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <count-text-area v-model="item.description[lang]" :placeholder="$t('common.text_' + lang)">
                      </count-text-area>
                    </div>
                  </div>

                  <b-form-group v-bind:label="$t('campaign.display_period')" :label-cols="2" :horizontal="true" >
                    <div role="group" class="input-group">
                      <masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-3 float-left border-radius-4px"
                        v-model="item.display_start"
                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>
                      <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                      </div>
                      <masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-3 float-left border-radius-4px"
                        v-model="item.display_end"
                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>
                    </div>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('campaign.url')" :label-cols="2" :horizontal="true" >
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.url"
                      :state="!$v.item.url.$invalid"
                      :aria-describedby="'name-url-feedback'"
                    />
                    <b-form-invalid-feedback :id="'name-url-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="row m-0 p-0" >
                  <div class="col-sm-6 row pt-3 m-0 p-0" v-for="(data, image, index) in imageData" :key="data.id">
                  <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
                    {{$t('campaign.'+image)}}
                    <!-- <i class="fa fa-info-circle text-primary" :id="'image-' + image"></i> -->
                    <b-tooltip :target="'image-' + image" placement="top">
                      <div class="text-left" v-html="getImageHelpInfo('campaign', image)"></div>
                    </b-tooltip>
                  </legend>
                  <div class="col-sm-8 ">
                    <b-form-file :id="image" @change="previewImage" accept="image/*" :placeholder="$t('message.choose_a_image')"></b-form-file>
                  </div>
                  <div v-bind:class="'image-' + image + '-preview img-min-height'" class="col-sm-8 offset-sm-4">
                    <img class="preview-image" v-bind:src="data">
                  </div>
                </div>
                </b-col>
              </b-form>
            </b-collapse>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'campaign', query: {rollback: 1}})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="btn-save">
                <button type="button" class=" pull-right btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveCampaign()" :disabled="checkSubmit() "> {{$t('common.save')}}</button>
              </div>
             </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import {required} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import CountTextArea from '../../../components/Partials/CountTextArea'

  let vm = null
  var defaultDateFrom = '01-01-2008'
  var defaultDateTo = '31-12-9999'
  export default {
    name: 'CampaignForm',
    props: {
      uuid: {
        type: String,
        required: true,
        default: 'create'
      }
    },
    components: {
      cSwitch,
      vSelect,
      MaskedInput,
      SelectDropdown,
      CustomizeField,
      CountTextArea
    },
    data: function () {
      return {
        images: ['background'],
        basicInformationStatus: true,
        lookFeelStatus: true,
        imageData: {},
        uploadImageUrl: '',
        xToken: '',
        client: localStorage.getItem('clientID'),
        item: {
          id: null,
          uuid: '',
          url: '',
          code: '',
          name: {},
          name_seo: {},
          description: {},
          image: {},
          active: 1
        }
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        },
        url: {
          required
        },
        name_seo: {
          required
        },
        code: {
          required
        }
      }
    },
    methods: {
      checkSubmit: function () {
        let validateName = false
        let form = vm.$v.item.$invalid
        return form || validateName
      },
      saveCampaign () {
        var data = JSON.parse(JSON.stringify(vm.item))
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        vm.axios.campaign.uploadCampaignImages(formData, config, function (response) {
          data.image = {}
          for (let i in response.data.data.item) {
            data.image[i] = response.data.data.item[i]
          }
          for (let i in oldUrl) {
            data.image[i] = oldUrl[i]
          }
          vm.imageData = data.image
          data.content = vm.item.content || ''
          data.display_start = vm.revertDateFormat(data.display_start)
          data.display_end = vm.revertDateFormat(data.display_end)
          if (vm.item.uuid == '' || vm.item.uuid == 'create') {
            vm.axios.campaign.createCampaign(data, function (response) {
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
            }, function () {
            })
          } else {
            vm.axios.campaign.updateCampaign(data, function (response) {
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            }, function () {
            })
          }
        })
      },
      /**
       * preview image after select
       * @param event
       */
      previewImage (event) {
        let input = event.target

        if (input.files && input.files[0]) {
          let reader = new FileReader()

          reader.onload = (e) => {
            this.imageData[input.id] = e.target.result
          }
          // this.imageData = []
          let data = {}
          for (let i in this.images) {
            data[this.images[i]] = this.imageData[this.images[i]]
          }
          this.imageData = data
          reader.readAsDataURL(input.files[0])
          this.item.image[input.id] = input.files[0]
        }
      },
      /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      updateLookFeelStatus () {
        this.lookFeelStatus = !this.lookFeelStatus
      },
      /**
       * revert date from DD-MM-YYYY to YYYY-MM-DD
       * @param val
       * @returns {*}
       */
      revertDateFormat (val) {
        let formatDate = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
        return this.convertDateTimeToUTC(formatDate)
      },
      /**
       * convert date from YYYY-MM-DD to DD-MM-YYYY
       * @param val
       * @returns {*}
       */
      convertDateFormat (val) {
        val = this.convertUTCToClientTime(val)
        return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
      }
    },
    created: function () {
      this.uploadImageUrl = process.env.host + '/' + process.env.version + '/' + process.env.prefix_campaign_be + '/campaign/upload-image-content'
      this.xToken = this.$auth.user().token

      vm = this
    },
    updated: function () {
    },
    mounted: function () {
      defaultDateFrom = this.$moment().format('DD-MM-YYYY')

      if (vm.uuid == 'create' || vm.uuid == undefined) {
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = ''
        }
        vm.imageData = data
      } else {
        vm.axios.campaign.getCampaignDetail(vm.uuid,
          function (response) {
            let item = response.data.data.item
            if (item.display_start == '' || item.display_start == 'Invalid date' || item.display_start == '__-__-____') {
              item.display_start = defaultDateFrom
            } else {
              item.display_start = vm.convertDateFormat(item.display_start)
            }

            if (item.display_end == '' || item.display_end == 'Invalid date' || item.display_end == '__-__-____') {
              item.display_end = defaultDateTo
            } else {
              item.display_end = vm.convertDateFormat(item.display_end)
            }
            if (item.description == null) {
              item.description = {'ja': '', 'en': ''}
            }
            vm.item = item
            for (let i in vm.images) {
              vm.imageData[vm.images[i]] = vm.item.image[vm.images[i]] != null ? vm.item.image[vm.images[i]] : ''
            }
          })
      }
    }
  }
</script>

<style scoped>

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }

  .campaign-form .switch.switch-icon{
    margin-top: 5px;
  }

  .campaign-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .campaign-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .campaign-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .campaign-form .btn-save{
    float: right !important;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
  /*END Form Wizard*/
</style>

<style>
  .preview-image {
    width: 100%;
  }

  .campaign-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .campaign-form div.header,
  .campaign-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .campaign-form .btn-primary .fa{
    font-size: 20px;
  }
  .campaign-form .btn-primary {
    color: #0091ff;
    background-color: transparent;
  }
  .campaign-form .btn-primary:hover{
    color: #0091ff;
    background-color: transparent;
  }
  .pt-05{
    padding: 0.5rem;
  }
  .pb-15{
    padding-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/campaign/Form.vue